export const sidebarIcon = [
  {
    id: 0,
    menuName: "Dashboard",
    menuIcon: "dashboard.svg",
    moduleId: 61,
  },
  {
    id: 0,
    menuName: "Admin",
    menuIcon: "adminmenu.svg",
    moduleId: 62,
    moduleUrl: "/dashboard/admin-menu",
  },
  {
    id: 0,
    menuName: "Accounts",
    menuIcon: "accountsmenu.svg",
    moduleId: 63,
  },
  {
    id: 0,
    menuName: "Beneficiaries",
    menuIcon: "beneficiariesmenu.svg",
    moduleId: 64,
  },
  {
    id: 0,
    menuName: "Payments",
    menuIcon: "paymentsmenu.svg",
    moduleId: 65,
  },
  {
    id: 0,
    menuName: "Payers",
    menuIcon: "beneficiariesmenu.svg",
    moduleId: 70,
  },
  {
    id: 0,
    menuName: "RTP",
    menuIcon: "rtpmenu.svg",
    moduleId: 68,
  },

  {
    id: 0,
    menuName: "Bulk Uploads",
    moduleId: 71,
    moduleUrl: null,
    menuIcon: "bulk-fileupload.svg",

    menus: [
      {
        menuId: 133,
        menuName: "File Upload",
        menuUrl: "/bulkuploads/uploadfile",
        menuIcon: null,
      },
      {
        menuId: 134,
        menuName: "Manage Bulk Files",
        menuUrl: "/bulkuploads/managebulkfile",
        menuIcon: null,
      },
    ],
  },
  {
    id: 0,
    menuName: "Reconciliation",
    menuIcon: "reconciliation.svg",
    moduleId: 78,
    moduleUrl: null,
    enableFlag: "Y",
    menus: [
      {
        menuId: 136,
        menuName: "Matched/Unmatched",
        menuUrl: "/reconciliation/matched&unMatched",
        menuIcon: null,
      },
    ],
  },

  {
    id: 0,
    menuName: "3rd Party Services",
    menuIcon: "3party.svg",
    moduleId: 72,
    moduleUrl: "/dashboard/thirdpartyservices",
  },

  {
    id: 0,
    menuName: "Bill Payments",
    menuIcon: "billpaymentsmenu.svg",
    moduleId: 66,
    moduleUrl: "/billpayments/billpaymentDashboard",
    enableFlag: "Y",
  },

  {
    id: 0,
    menuName: "Invoices",
    menuIcon: "eippmenu.svg",
    moduleId: 69,
    moduleUrl: "/invoice/invoiceDashboard",
    enableFlag: "Y",
  },

  {
    id: 0,
    menuName: "Direct Debits",
    menuIcon: "direct-debit-icon.svg",
    moduleId: 74,
    moduleUrl: "/direct-debit-dashboard",
  },

  {
    id: 0,
    menuName: "CFO Co-Pilot",
    menuIcon: "ix_ai.svg",
    moduleId: 73,
    moduleUrl: "/CFO/dashboard",
  },

  // 🔽 BOTTOM MENU (STATIC)
  {
    id: 100,
    menuName: "Settings",
    menuIcon: "settings.svg",
    moduleUrl: "/settings",
    position: "bottom",
  },
  {
    id: 101,
    menuName: "Support",
    menuIcon: "supports.svg",
    moduleUrl: "/support",
    position: "bottom",
  },
  // {
  //   id: 102,
  //   menuName: "Reports",
  //   menuIcon: "reports.svg",
  //   moduleUrl: "/reports",
  //   position: "bottom",
  // },
  {
    id: 103,
    menuName: "About Us",
    menuIcon: "aboutus.svg",
    moduleUrl: "/aboutUs",
    position: "bottom",
  },
];
